import {
  disableCcmModuleStatuses,
  disableRpmModuleStatuses,
  readonlyCcmModuleStatuses,
  readonlyRpmModuleStatuses,
} from 'infrastructure/consts/statuses';

import type { CcmStatuses, RpmStatuses } from 'infrastructure/enums';

export const hasStatusForDisableCcmModule = (ccmStatus: CcmStatuses) =>
  disableCcmModuleStatuses.includes(ccmStatus);

export const hasStatusForDisableRpmModule = (rpmStatus: RpmStatuses) =>
  disableRpmModuleStatuses.includes(rpmStatus);

export const hasStatusForReadonlyCcmModule = (ccmStatus: CcmStatuses) =>
  readonlyCcmModuleStatuses.includes(ccmStatus);

export const hasStatusForReadonlyRpmModule = (rpmStatus: RpmStatuses) =>
  readonlyRpmModuleStatuses.includes(rpmStatus);
